// Avertissement bénin émis sans exception attachée : un callback ResizeObserver a modifié une
// taille observée, le navigateur livre les notifications restantes à la frame suivante.
function isResizeObserverLoopNotice(message: string): boolean {
  return message.includes("ResizeObserver loop");
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vue:error", (error, _instance, info) => {
    console.error("[vue-error]", info, error);
  });

  nuxtApp.hook("app:error", (error) => {
    console.error("[app-error]", error);
  });

  if (import.meta.client) {
    window.addEventListener("unhandledrejection", (event) => {
      console.error("[unhandledrejection]", event.reason);
    });
    window.addEventListener("error", (event) => {
      if (isResizeObserverLoopNotice(event.message)) return;
      console.error("[window-error]", event.message, event.error);
    });
  }
});
